/** @jsxImportSource @emotion/react */
import React from 'react'

interface QRCodeIconProps {
  size?: number
  color?: string
  className?: string
}

const QRCodeIcon: React.FC<QRCodeIconProps> = ({
  size = 16,
  color = 'white',
  className,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    className={className}
  >
    <path
      d='M1.33333 7.33333H7.33333V1.33333H1.33333V7.33333ZM2.66667 2.66667H6V6H2.66667V2.66667Z'
      fill={color}
    />
    <path
      d='M8.66667 1.33333V7.33333H14.6667V1.33333H8.66667ZM13.3333 6H10V2.66667H13.3333V6Z'
      fill={color}
    />
    <path
      d='M1.33333 14.6667H7.33333V8.66667H1.33333V14.6667ZM2.66667 10H6V13.3333H2.66667V10Z'
      fill={color}
    />
    <path d='M3.66667 3.66667H5V5H3.66667V3.66667Z' fill={color} />
    <path d='M11 3.66667H12.3333V5H11V3.66667Z' fill={color} />
    <path d='M3.66667 11H5V12.3333H3.66667V11Z' fill={color} />
    <path d='M8.66667 8.66667H10V10H8.66667V8.66667Z' fill={color} />
    <path d='M11 10H12.3333V11.3333H11V10Z' fill={color} />
    <path d='M13.3333 8.66667H14.6667V10H13.3333V8.66667Z' fill={color} />
    <path d='M8.66667 11.3333H10V12.6667H8.66667V11.3333Z' fill={color} />
    <path d='M11 12.6667H12.3333V14H11V12.6667Z' fill={color} />
    <path d='M13.3333 11.3333H14.6667V14.6667H13.3333V11.3333Z' fill={color} />
  </svg>
)

export default QRCodeIcon
